import { inject, Injectable } from '@angular/core';
import { UIService } from '@core/services';
import { defer, finalize } from 'rxjs';
import { ApiService } from './api.service';
import { ResendEmail } from './model';

@Injectable()
export class Service {
  private readonly api = inject(ApiService);
  private readonly ui = inject(UIService);

  getOperation(paymentId: number, signature: string) {
    return defer(() => {
      this.ui.freeze();
      return this.api.getOperation(paymentId, signature);
    }).pipe(finalize(() => this.ui.unFreeze()));
  }

  resendEmail(model: ResendEmail) {
    return defer(() => {
      this.ui.freeze();
      return this.api.resendEmail(model);
    }).pipe(finalize(() => this.ui.unFreeze()));
  }
}
